import { findIndexByPropertyValue } from 'utilities/collection';

class SocialNetworkOperators {

  constructor(serverInterface) {

    this.loaded = false;
    this.operators = [];
    this.serverInterface = serverInterface;

  }

  async loadOperators() {

    const operators = await this.serverInterface.startup.socialNetworkOperators.getOperatorsByStartupId();

    this.operators = operators;

  }

  async load() {

    if (this.loaded === true) {
      return;
    }

    await this.loadOperators();

    this.loaded = true;

  }

  isLinkedInActive() {

    const index = findIndexByPropertyValue(this.operators, 'network', 'LINKED_IN');

    if (index === -1) {
      return false;
    }

    const operator = this.operators[index];

    return operator.status === 'ACTIVE';

  }

  isTwitterActive() {

    const index = findIndexByPropertyValue(this.operators, 'network', 'TWITTER');

    if (index === -1) {
      return false;
    }

    const operator = this.operators[index];

    return operator.status === 'ACTIVE';

  }

  async createOperator(operator) {

    const newOperator = await this.serverInterface.startup.socialNetworkOperators.createOperator(operator);

    this.operators.push(newOperator);

  }

  async updateOperatorById(operatorId, operator) {

    await this.serverInterface.startup.socialNetworkOperators.updateOperatorById(operatorId, operator);

    const index = findIndexByPropertyValue(this.operators, '_id', operatorId);

    this.operators[index] = { ...operator, status: 'ACTIVE' };

  }

  async deactivateOperatorById(operatorId) {

    await this.serverInterface.startup.socialNetworkOperators.deactivateOperatorById(operatorId);

    const index = findIndexByPropertyValue(this.operators, '_id', operatorId);

    this.operators.splice(index, 1);

  }

  getOperators() {

    return this.operators;

  }

}

export default SocialNetworkOperators;